<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Return</span>
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Return</h6>
  </d-card-header>
        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link> -->
    

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>
          
                           <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Panel *</label>
                    <div class="col-md-4">
                      <select class="form-control" @change="panelOnchange()" v-model="Return.DataModel.Data.PanelInfo">
                    <option style="padding:50px" v-for="Dropdown in Return.Masters.PanelList" :value="Dropdown"
                      :key="Dropdown.ReferenceNo" >{{ Dropdown.Name }}</option>
                    </select>
                    </div>
                 </d-col>
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Payment Details</label>
                    <div class="col-md-7" v-if="Return.DataModel.UIData.UploadedDataCount == 0">   
                     
                         <div class="button_group">
                          <d-button type="button" id="submit" title="Please Select the panel"   class="btn-accent" @click="getQuery" style="margin-right:10px" >fetch Data</d-button>
                          <!-- <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button> -->
                          </div>
                    </div>
                     
                  </d-col>

                </d-form-row>
                <br />
                <!-- <div class style="text-align:center">
                  <d-button type="button" id="submit" title="Please Select the panel" :disabled="(Return.DataModel.Data.PanelInfo.Country == null || Return.DataModel.Data.FromCountry ==null || Return.DataModel.UIData.TemplateIsAvailable)" class="btn-accent" @click="GetList" style="margin-right:10px" >Submit</d-button>
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div> -->
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="Return.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
export default {
  name: 'Return',
   data() {
    return {
      Return: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            PanelInfo:{
              Name:null,
              Country:null
            },
            FromCountry:null,
            GenericInputCount:[],
            Token:null,
            Curd:null,
            CreatedBy:0
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            currentStep:0,
            Template:[],
            minMaxList:[],
            GenericInputTemplate:[],
            AvailablityList:[],
            GenericInputTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            }
          ]
        },
      },
    };
  },

  mounted(){
      this.Return.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.Return.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.Return.DataModel.Data.FromCountry = null;
     document.getElementById("pricing").reset();
},

panelOnchange(){

            this.Return.DataModel.UIData.Template=[];
            this.Return.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.Return.DataModel.UIData.Template = [];
            this.Return.DataModel.UIData.TemplateIsAvailable = false;
            this.Return.DataModel.Data.GenericInputCount = 0;
            this.Return.DataModel.UIData.UploadedDataCount = 0;
            this.Return.DataModel.UIData.GenericInputTemplateCount=false;
        this.Return.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.Return.DataModel.Data.FromCountry =null;
        this.Return.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
      },

      ListAllFromCountry(){
      let vm = this;
      vm.Return.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.Return.DataModel.Data.Token = Token;
      this.Return.DataModel.Data.CRUD = "ListAllFromCountry";
      var dataString = JSON.stringify(this.Return.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.Return.PageLoad = false;
            vm.Return.Masters.CountryMaster = response.data.Result;
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.Return.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },


getQuery()
{

        let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.Return.DataModel.Data.Token = Token;
      this.Return.DataModel.Data.CRUD = "UpdateOrderId";
      this.Return.DataModel.UIData.FileName = this.Return.DataModel.Data.PanelInfo.Name + " " + Date.now();
      var dataString = JSON.stringify(this.Return.DataModel.Data);
       vm.Return.PageLoad = true;
       vm.Return.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/ReturnPayment.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.Return.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
              console.log(response.data.Result);  
            vm.Return.DataModel.UIData.UploadedDataCount = response.data.Result;
 
          } else {
              console.log(response.data.ErrorInfo);
              vm.Return.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.Return.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},



      GetList(){
      let vm = this;
      vm.Return.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.Return.DataModel.Data.Token = Token;
      
      this.Return.DataModel.UIData.FileName = this.Return.DataModel.Data.PanelInfo.Name + " " + Date.now();
      this.Return.DataModel.UIData.AvailabilityFileName = this.Return.DataModel.Data.PanelInfo.Name + "UnAvailability" + " " + Date.now();
      this.Return.DataModel.UIData.AvailabilityTemplateFileName = this.Return.DataModel.Data.PanelInfo.Name + "Availability" + " " + Date.now();
      this.Return.DataModel.UIData.MinMaxFileName = this.Return.DataModel.Data.PanelInfo.Name + "Min and Max Pricing" + " " + Date.now();
      this.Return.DataModel.Data.CreatedBy = this.Return.SessionInfo.PageInfo.userId;
      var ListParameter = Utilities.JsonCopy(this.Return.DataModel.Data);

      ListParameter.GenericInputCount = [];
      var dataString = null;
        
        ListParameter.CRUD = "GetGenericInputList";
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);
      },


      ReturnData(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.Return.DataModel.Data.Token = Token;
      this.Return.DataModel.Data.CRUD = "Create";
      this.Return.DataModel.UIData.FileName = this.Return.DataModel.Data.PanelInfo.Name + " " + Date.now();
      var dataString = JSON.stringify(this.Return.DataModel.Data);
       vm.Return.PageLoad = true;
       vm.Return.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.Return.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
              console.log(response.data.Result);  
            vm.Return.DataModel.UIData.UploadedDataCount = response.data.Result;
 
          } else {
              console.log(response.data.ErrorInfo);
              vm.Return.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.Return.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },

  // UploadedDataCount

  
      GetGenericInputList(dataString){
       let vm = this;
       
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.Return.PageLoad = false;
            vm.$toaster.success("Successfully Generated.");
            vm.Return.DataModel.UIData.GenericInputTemplate= response.data.Result              
            if(vm.Return.DataModel.UIData.GenericInputTemplate.length > 0)
            vm.Return.DataModel.UIData.GenericInputTemplateCount = true;

          } else {
              console.log(response.data.ErrorInfo);
                vm.Return.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Data !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.Return.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },

  
    AmazonTemplate(dataString){
       let vm = this;
        vm.Return.DataModel.Data.CRUD = "GetAmazonList";
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.Return.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);

            response.data.Result.map(function(key,value){

                key.minimum_Buybox_seller_allowed_price=Math.ceil(key.price - ((10/100) * key.price));	
                key.maximum_Buybox_seller_allowed_price=Math.ceil(Number((10/100) * key.price) + Number(key.price));

            });

            vm.Return.DataModel.UIData.Template = response.data.Result;
            
            if(vm.Return.DataModel.UIData.Template.length > 0)
            vm.Return.DataModel.UIData.TemplateIsAvailable = true;
          } else {
              console.log(response.data.ErrorInfo);
                vm.Return.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.Return.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },


    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */
     importExcel(e) {

      const files = e.target.files;
      this.Return.PageLoad = true;
      this.Return.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.Return.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the dat   a of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000


          this.Return.DataModel.Data.GenericInputCount = 0 ;
          this.Return.DataModel.Data.QueryString = "INSERT INTO `PaymentDetails` (`item_nr`, `partner_sku`, `sku`, `statement_nr`, `item_status`, `commission_type`, `sla_type`, `shipped_date`, `delivered_date`, `currency_code`, `base_price`, `seller_promo`, `seller_price`, `fee_closing`, `payment_due`, `previous_fee_closing`, `payment_statement`, `CreatedAt`) VALUES";


          // for (var i = 0; i < loopCount; i++) {

          // }


          for (var i = 0; i < ws.length; i++) {


            var PaymentDetails={
           
           item_nr:null,	
          partner_sku:null,	
          sku:null,	
          statement_nr:null,	
          item_status:null,	
          commission_type:null,	
          sla_type:null,	
          shipped_date:null,	
          delivered_date:null,	
          base_price:null,	
          seller_promo:null,	
          seller_price:null,
          fee_closing:null,
          payment_due:null,	
          previous_fee_closing:null,	
          payment_statement:null
              // ASIN:null,
              // Category:null,
              // Country:null,
              // buybox_new_landed_price:null, 
              // Weight:null,
              // FromPanel:null,
              // Buybox_seller:null


            }


            if(ws[i].item_nr!=undefined)
            {
                PaymentDetails.item_nr= ws[i].item_nr;
            }
            else
            {
              PaymentDetails.item_nr= null;
            }

            if(ws[i].partner_sku !=undefined )
            {
                 PaymentDetails.partner_sku = ws[i].partner_sku;
            }
            else
            {
                PaymentDetails.partner_sku = 0;
            }
            if(ws[i].sku !=undefined)
            {
                PaymentDetails.sku = ws[i].sku;
            }
            else
            {
              PaymentDetails.sku = null;
            }

            if(ws[i].statement_nr !=undefined )
            {
                 PaymentDetails.statement_nr = ws[i].statement_nr;
            }
            else
            {
                PaymentDetails.statement_nr = 0;
            }

            if(ws[i].item_status !=undefined)
            {
                PaymentDetails.item_status = ws[i].item_status;
            }
            else
            {
              PaymentDetails.item_status = null;
            }

            if(ws[i].commission_type !=undefined)
            {
                PaymentDetails.commission_type = ws[i].commission_type;
            }
            else
            {
              PaymentDetails.commission_type = null;
            }
            
            if(ws[i].sla_type !=undefined)
            {
                PaymentDetails.sla_type = ws[i].sla_type;
            }
            else
            {
              PaymentDetails.sla_type = null;
            } 

            if(ws[i].shipped_date!=undefined)
            {
                PaymentDetails.shipped_date= new Date((ws[i].shipped_date - (25567 + 1))*86400*1000).getFullYear() + "-" + new Date((ws[i].shipped_date - (25567 + 1))*86400*1000).getMonth() +  "-" + new Date((ws[i].shipped_date - (25567 + 1))*86400*1000).getDate();
                console.log(PaymentDetails.shipped_date);
            }
            else
            {
              PaymentDetails.shipped_date= null;
            }

            if(ws[i].delivered_date !=undefined )
            {
                 PaymentDetails.delivered_date = new Date((ws[i].delivered_date - (25567 + 1))*86400*1000).getFullYear() + "-" + new Date((ws[i].delivered_date - (25567 + 1))*86400*1000).getMonth() +  "-" + new Date((ws[i].delivered_date - (25567 + 1))*86400*1000).getDate(); 
                 console.log(PaymentDetails.delivered_date);
            }
            else
            {
                PaymentDetails.delivered_date = 0;
            }
            if(ws[i].sku !=undefined)
            {
                PaymentDetails.sku = ws[i].sku;
            }
            else
            {
              PaymentDetails.sku = null;
            }

            if(ws[i].base_price !=undefined )
            {
                 PaymentDetails.base_price = ws[i].base_price;
            }
            else
            {
                PaymentDetails.base_price = 0;
            }

            if(ws[i].seller_promo !=undefined)
            {
                PaymentDetails.seller_promo = ws[i].seller_promo;
            }
            else
            {
              PaymentDetails.seller_promo = null;
            }

            if(ws[i].seller_price !=undefined)
            {
                PaymentDetails.seller_price = ws[i].seller_price;
            }
            else
            {
              PaymentDetails.seller_price = null;
            }
            
            if(ws[i].fee_closing !=undefined)
            {
                PaymentDetails.fee_closing = ws[i].fee_closing;
            }
            else
            {
              PaymentDetails.fee_closing = null;
            }

            if(ws[i].payment_due!=undefined)
            {
                PaymentDetails.payment_due= ws[i].payment_due;
            }
            else
            {
              PaymentDetails.payment_due= null;
            }

            if(ws[i].previous_fee_closing !=undefined )
            {
                 PaymentDetails.previous_fee_closing = ws[i].previous_fee_closing;
            }
            else
            {
                PaymentDetails.previous_fee_closing = 0;
            }
            if(ws[i].payment_statement !=undefined)
            {
                PaymentDetails.payment_statement = ws[i].payment_statement;
            }
            else
            {
              PaymentDetails.payment_statement = null;
            }

            if(ws[i].base_price !=undefined )
            {
                 PaymentDetails.base_price = ws[i].base_price;
            }
            else
            {
                PaymentDetails.base_price = 0;
            }

            if(ws[i].currency_code !=undefined )
            {
                 PaymentDetails.currency_code = ws[i].currency_code;
            }
            else
            {
                PaymentDetails.currency_code = 0;
            }

       

            this.Return.DataModel.Data.QueryString = this.Return.DataModel.Data.QueryString + "(\'" + PaymentDetails.item_nr + "\',\'" + PaymentDetails.partner_sku + "\',\'" + PaymentDetails.sku + "\',\'" + PaymentDetails.statement_nr + "\',\'" + PaymentDetails.item_status + "\',\'" + PaymentDetails.commission_type + "\',\'" + PaymentDetails.sla_type + "\',\'" + PaymentDetails.shipped_date + "\',\'" + PaymentDetails.delivered_date + "\',\'" + PaymentDetails.currency_code + "\',\'" + PaymentDetails.base_price + "\',\'" + PaymentDetails.seller_promo + "\',\'" + PaymentDetails.seller_price + "\',\'" + PaymentDetails.fee_closing + "\',\'" + PaymentDetails.payment_due + "\',\'" + PaymentDetails.previous_fee_closing + "\',\'" + PaymentDetails.payment_statement + "\',\'NOW()\' )";

            if(i < (ws.length - 1))
            {
              this.Return.DataModel.Data.QueryString = this.Return.DataModel.Data.QueryString+"," 
            }
            this.Return.DataModel.Data.GenericInputCount +=1;
            
            // this.Return.DataModel.Data.GenericInputCount.push(PaymentDetails);
            //  excellist.push(ws[i]);
          }

          
           this.Return.DataModel.Data.QueryString = this.Return.DataModel.Data.QueryString+";"
           console.log("Read results", this.Return.DataModel.Data.QueryString); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log('headers', this.Return.DataModel.Data.GenericInputCount);  
          this.Return.PageLoad = false;
        //    console.log(this.Return.DataModel.Data.QueryString); 
          // this.Return.DataModel.Data.QueryString = JSON.stringify(this.Return.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            this.Return.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },	

 previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       }


  }
}
</script>